<app-modal *ngIf="show" [titleModal]="'Criar usuário'">
  <div modal-button-close>
    <app-button (buttonClick)="onClose()" [hasIcon]="true" buttonStyle="close">
      <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd"
          d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
          clip-rule="evenodd"></path>
      </svg>
    </app-button>
  </div>

  <!-- Loading State -->
  <div *ngIf="isLoadingCreateUser && !successCreateUser" class="p-10 flex justify-center w-full" role="status">
    <svg aria-hidden="true" class="w-16 h-16 text-gray-200 animate-spin dark:text-gray-600 fill-blue-500"
      viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
        fill="currentColor" />
      <path
        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
        fill="currentFill" />
    </svg>
    <span class="sr-only">Loading...</span>
  </div>

  <!-- Success State -->
  <div *ngIf="successCreateUser" class="w-full h-auto flex justify-center md:shrink-0">
    <div class="w-1/2 h-64 flex flex-col items-center md:shrink-0">
      <svg class="w-20 h-20 text-green-500 mb-4" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
      </svg>
      <div class="w-full mt-2 text-center">
        <h2 class="font-semibold text-base">Usuário criado com sucesso!</h2>
      </div>
    </div>
  </div>

  <!-- Form -->
  <form *ngIf="!isLoadingCreateUser && !successCreateUser" [formGroup]="formCreateUser">
    <!-- Info da loja pré-selecionada -->
    <div *ngIf="preSelectedStore" class="mb-6 bg-blue-50 border border-blue-200 rounded-lg p-4">
      <div class="flex items-start space-x-3">
        <div class="flex-shrink-0">
          <svg class="w-6 h-6 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M4 4a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2H4zm2 6a2 2 0 114 0 2 2 0 01-4 0zm8-1a1 1 0 10-2 0 1 1 0 002 0z" clip-rule="evenodd"></path>
          </svg>
        </div>
        <div class="flex-1">
          <h4 class="text-sm font-semibold text-blue-800">Loja selecionada</h4>
          <p class="text-sm text-blue-700 font-medium">
            {{ preSelectedStore.trade_name || preSelectedStore.company_name }}
          </p>
          <p class="text-xs text-blue-600">
            CNPJ: {{ preSelectedStore.cnpj }}
          </p>
        </div>
      </div>
    </div>

    <div class="grid grid-cols-6 gap-6">
      <!-- Email -->
      <div class="col-span-6">
        <div class="flex flex-col ml-1 mb-1">
          <label for="email" class="text-xs font-semibold">E-mail</label>
        </div>
        <input 
          type="email" 
          name="email" 
          id="email" 
          formControlName="email" 
          aria-describedby="email-conflict"
          class="col-span-6 focus:bg-transparent bg-gray-50 disabled:bg-gray-50 border border-gray-300 text-gray-500 text-sm rounded-lg focus:ring-black focus:border-black block w-full px-2.5 py-4"
          [ngClass]="{
            'bg-green-50 border-2 border-green-500 focus:ring-green-500 text-green-900 focus:border-green-500': formCreateUser.get('email')?.valid,
            'bg-red-50 border-2 border-red-500 focus:ring-red-500 text-red-900 focus:border-red-500': formCreateUser.get('email')?.invalid && (formCreateUser.get('email')?.dirty || formCreateUser.get('email')?.touched) || emailConflictExists
          }" 
          placeholder="exemplo@company.com" 
          required>
        <p id="email-conflict" *ngIf="emailConflictExists" class="mt-2 text-xs text-red-600 dark:text-red-500">
          <span class="font-medium">Ops!</span> {{ emailErrorMessage }}
        </p>
      </div>

      <!-- Permissão -->
      <div class="col-span-6">
        <div class="flex flex-col ml-1 mb-1">
          <label for="permission" class="text-xs font-semibold">Permissão</label>
        </div>
        <select 
          name="permission" 
          id="permission" 
          formControlName="permission"
          class="col-span-6 focus:bg-transparent bg-gray-50 disabled:bg-gray-50 border border-gray-300 text-gray-500 text-sm rounded-lg focus:ring-black focus:border-black block w-full px-2.5 py-4">
          <option value="">Selecione uma permissão</option>
          <option value="licenciado-chat">Licenciado chat</option>
          <option value="freemium">Usuário Freemium</option>
          <option value="licenciado-marketing">Acesso ao Marketing</option>
          <option value="licenciado-shopping">Acesso a Compras</option>
        </select>
      </div>

      <!-- Grupo Econômico -->
      <div class="col-span-6" *ngIf="!isPreSelectedMode" (mouseleave)="isCreateEconomicGroupListVisible = false">
        <div class="flex flex-col ml-1 mb-1">
          <label for="economicGroup" class="text-xs font-semibold">Associar grupo econômico</label>
          <div class="w-full border-l-4 border-l-amber-400 pl-2 flex my-2">
            <p class="text-xs font-medium">Selecionando o Grupo Econômico você da acesso a todos os CNPJ's do grupo</p>
          </div>
        </div>
        <div>
          <div class="relative">
            <input 
              id="economicGroup" 
              formControlName="economicGroup" 
              type="text" 
              autocomplete="off"
              [disabled]="isPreSelectedMode"
              (click)="!isPreSelectedMode && (isCreateEconomicGroupListVisible = true)"
              (keypress)="!isPreSelectedMode && (isCreateEconomicGroupListVisible = true)"
              (input)="onSearchCreateEconomicGroup()"
              [placeholder]="isPreSelectedMode ? 'Grupo pré-selecionado automaticamente' : ''"
              class="col-span-6 focus:bg-transparent bg-gray-50 disabled:bg-gray-50 border border-gray-300 text-gray-500 text-sm rounded-lg focus:ring-black focus:border-black block w-full px-2.5 py-4">
            
            @if (isCreateEconomicGroupListVisible) {
            <div class="absolute p-1 border border-gray-300 h-auto rounded-md z-40 w-full mt-1 max-h-40 bg-white scrollbar-thin overflow-auto scrollbar-thumb-black scrollbar-track-transparent animate-fade-down animate-duration-200 animate-ease-out">
              <ul>
                @for (item of filteredEconomicGroup; track $index) {
                <li (click)="addGrupoEconomico(item)" class="group cursor-pointer w-full flex p-3 rounded-md hover:bg-gray-100 text-sm">
                  <div class="grow">{{ item.economic_group_name }}</div>
                </li>
                }
                @if (filteredEconomicGroup.length <= 0) {
                <li class="cursor-pointer p-3 rounded-md hover:bg-gray-100 text-sm">Nada encontrado...</li>
                }
              </ul>
            </div>
            }
          </div>
        </div>

        <!-- Grupos econômicos selecionados -->
        <div class="w-full mt-2 max-h-28 overflow-auto">
          @for (item of gruposEconomicos; track $index) {
          <span class="animate-fade-down animate-duration-[600ms] animate-ease-in-out mt-2 inline-flex items-center px-2 py-1 me-2 text-xs font-semibold text-green-800 bg-green-100 rounded">
            {{ item.economic_group_name }}
            @if (!isPreSelectedMode) {
            <button 
              type="button"
              class="inline-flex items-center p-1 ms-2 text-sm text-green-400 bg-transparent rounded-sm hover:bg-green-200 hover:text-green-900"
              (click)="removeGrupoEconomico(item)" 
              aria-label="Remove">
              <svg class="w-2 h-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
              </svg>
            </button>
            } @else {
            <span class="inline-flex items-center p-1 ms-2 text-xs text-green-600">
              (pré-selecionado)
            </span>
            }
          </span>
          }
        </div>
      </div>

      <!-- Grupo Econômico (Apenas visualização no modo pré-selecionado) -->
      <div class="col-span-6" *ngIf="isPreSelectedMode && preSelectedStore?.economic_group">
        <div class="flex flex-col ml-1 mb-1">
          <label class="text-xs font-semibold">Grupo Econômico</label>
        </div>
        <div class="w-full p-4 bg-gray-50 border border-gray-200 rounded-lg">
          <div class="flex items-center">
            <div class="flex-shrink-0 h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 font-bold text-lg">
              {{ preSelectedStore?.economic_group?.economic_group_name?.charAt(0) || 'G' }}
            </div>
            <div class="ml-4">
              <div class="text-sm font-medium text-gray-900">{{ preSelectedStore?.economic_group?.economic_group_name }}</div>
              <div class="text-xs text-gray-500">Grupo vinculado à loja</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Associar CNPJ -->
      <div class="col-span-6">
        <div class="flex flex-col ml-1 mb-1">
          <label for="cnpj" class="text-xs font-semibold">Associar CNPJ</label>
          <div class="w-full border-l-4 border-l-amber-400 pl-2 flex my-2">
            <p class="text-xs font-medium">Selecionando o CNPJ você da acesso apenas ao escolhido</p>
          </div>
        </div>
        <div>
          <div class="relative">
            <!-- Backdrop for closing dropdown -->
            <div *ngIf="isCreateCNPJListVisible" class="fixed inset-0 z-30" (click)="isCreateCNPJListVisible = false"></div>

            <input 
              id="cnpj" 
              formControlName="cnpj" 
              type="text" 
              autocomplete="off"
              (click)="isCreateCNPJListVisible = true"
              (keypress)="isCreateCNPJListVisible = true"
              (input)="onSearchCreateCNPJ()"
              placeholder=""
              class="col-span-6 focus:bg-transparent bg-gray-50 disabled:bg-gray-50 border border-gray-300 text-gray-500 text-sm rounded-lg focus:ring-black focus:border-black block w-full px-2.5 py-4 relative z-40">
            
            @if (isCreateCNPJListVisible) {
            <div class="absolute p-1 border border-gray-300 h-auto rounded-md z-40 w-full mt-1 max-h-60 bg-white scrollbar-thin overflow-auto scrollbar-thumb-black scrollbar-track-transparent animate-fade-down animate-duration-200 animate-ease-out shadow-lg">
              <ul>
                @if (isPreSelectedMode && preSelectedStore?.economic_group) {
                <li (click)="toggleAllGroupCNPJs()" class="group cursor-pointer w-full flex p-3 rounded-md hover:bg-blue-50 text-sm font-medium text-blue-600 border-b border-gray-100 mb-1 items-center">
                  <div class="flex items-center h-5 mr-2">
                    <input type="checkbox" [checked]="isAllGroupCNPJsSelected()" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 pointer-events-none">
                  </div>
                  <div class="grow flex items-center gap-2">
                    Selecionar todos do grupo {{ preSelectedStore?.economic_group?.economic_group_name }}
                  </div>
                </li>
                }
                @for (item of filteredCNPJ; track $index) {
                <li (click)="toggleCNPJ(item)" class="group cursor-pointer w-full flex p-3 rounded-md hover:bg-gray-100 text-sm items-center">
                  <div class="flex items-center h-5 mr-2">
                    <input type="checkbox" [checked]="isCNPJSelected(item)" [disabled]="isPreSelectedMode && preSelectedStore?.cnpj === item.cnpj" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 pointer-events-none">
                  </div>
                  <div class="grow">{{ item.cnpj }} - {{ item.company_name || item.trade_name }}</div>
                </li>
                }
                @if (filteredCNPJ.length <= 0) {
                <li class="cursor-pointer p-3 rounded-md hover:bg-gray-100 text-sm">Nada encontrado...</li>
                }
              </ul>
            </div>
            }
          </div>
        </div>
      </div>

      <!-- CNPJs selecionados -->
      <div class="col-span-6">
        <div class="flex flex-col ml-1 mb-1">
          <label class="text-xs font-semibold">CNPJs selecionados</label>
          <div class="w-full border-l-4 border-l-amber-400 pl-2 flex my-2">
            <p class="text-xs font-medium">CNPJs associados ao usuário</p>
          </div>
        </div>

        <!-- Lista de CNPJs -->
        <div class="w-full mt-2 max-h-28 overflow-auto">
          @for (item of cnpjList; track $index) {
          <span class="animate-fade-down animate-duration-[600ms] animate-ease-in-out mt-2 inline-flex items-center px-2 py-1 me-2 text-xs font-semibold rounded"
            [ngClass]="{
              'text-blue-800 bg-blue-100': isPreSelectedMode && preSelectedStore?.cnpj === item.cnpj,
              'text-green-800 bg-green-100': !isPreSelectedMode || preSelectedStore?.cnpj !== item.cnpj
            }">
            {{ item.cnpj }}
            @if (!isPreSelectedMode || (isPreSelectedMode && preSelectedStore?.cnpj !== item.cnpj)) {
            <button 
              type="button"
              class="inline-flex items-center p-1 ms-2 text-sm bg-transparent rounded-sm"
              [ngClass]="{
                'text-blue-400 hover:bg-blue-200 hover:text-blue-900': isPreSelectedMode && preSelectedStore?.cnpj === item.cnpj,
                'text-green-400 hover:bg-green-200 hover:text-green-900': !isPreSelectedMode || preSelectedStore?.cnpj !== item.cnpj
              }"
              (click)="removeCNPJ(item)" 
              aria-label="Remove">
              <svg class="w-2 h-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
              </svg>
              <span class="sr-only">Remove badge</span>
            </button>
            } @else {
            <span class="inline-flex items-center p-1 ms-2 text-xs text-blue-600">
              (pré-selecionado)
            </span>
            }
          </span>
          }

          <!-- Mensagem quando não há CNPJs selecionados -->
          @if (cnpjList.length === 0) {
          <div class="text-xs text-gray-500 italic p-2 bg-gray-50 rounded border-2 border-dashed border-gray-200">
            Nenhum CNPJ selecionado. Selecione um grupo econômico ou CNPJ individual.
          </div>
          }
        </div>
      </div>
    </div>

    <!-- Alerta de Grupo Econômico Ausente -->
    <div *ngIf="isPreSelectedMode && !preSelectedStore?.economic_group" class="p-4 mt-4 rounded-lg bg-yellow-50 border border-yellow-200">
      <div class="flex items-start">
        <div class="flex-shrink-0">
          <svg class="w-5 h-5 text-yellow-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
          </svg>
        </div>
        <div class="ml-3">
          <h3 class="text-sm font-medium text-yellow-800">Atenção: Loja sem Grupo Econômico</h3>
          <div class="mt-2 text-sm text-yellow-700">
            <p>Esta loja não possui um Grupo Econômico vinculado. Recomendamos editar o cadastro da loja e adicionar um grupo antes de criar usuários.</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Erro de seleção -->
    @if(selectionError) {
    <div class="p-4 mt-4 rounded-lg bg-red-100">
      <p class="text-xs text-red-800">Por favor, selecione ao menos um CNPJ ou Grupo econômico</p>
    </div>
    }
  </form>

  <div *ngIf="!isLoadingCreateUser && !successCreateUser" modal-footer>
    <app-button 
      (buttonClick)="onSubmitCreateUser()" 
      [isDisabled]="(!formCreateUser.valid || emailConflictExists) || (gruposEconomicos.length === 0 && cnpjList.length === 0)"
      [buttonType]="'submit'">
      Salvar
    </app-button>
  </div>
</app-modal>
